import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useRefreshAllMessages } from '../../hooks/useRefreshAllMessages';

interface RefreshAllButtonProps { 
  onSuccess?: () => void;
  iconOnly?: boolean;
}

export default function RefreshAllButton({ onSuccess, iconOnly = false }: RefreshAllButtonProps) {
  const { refreshAll, refreshing } = useRefreshAllMessages();

  const handleRefresh = async () => {
    try {
      await refreshAll();
      onSuccess?.();
    } catch (err) {
      console.error('Failed to refresh all messages:', err);
    }
  };

  return (
    <button
      onClick={handleRefresh}
      disabled={refreshing}
      className={`btn btn-secondary flex items-center ${iconOnly ? 'h-[42px] w-[42px] justify-center p-0' : 'gap-2'}`}
      title={iconOnly ? 'Refresh All' : undefined}
    >
      <RefreshCw className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} />
      {!iconOnly && (refreshing ? 'Refreshing All...' : 'Refresh All')}
    </button>
  );
}